import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import "./SuperAdminDashboard.css";
import {
  VYLABS_BASE_URL,
  NOTIFICATIONS_GET,
  WEB_SOCKET_URL,
  SUPERADMIN_METRICS_ACTIVITY_BY_TENANT,
  SUPERADMIN_METRICS_ACTIVITY_BY_USER,
  SUPERADMIN_TENANT_SUBSCRIPTION,
  EXPORT_SUPERADMIN_METRICS_ACTIVITY_BY_TENANT,
  EXPORT_SUPERADMIN_METRICS_ACTIVITY_BY_USER,
} from "../../../helper/url_helper";

import { get } from "../../../helper/Api_helper";
import { DynamicContext } from "../../../Context/DynamicContext";

import notificationIcon from "../../../Assets/Images/notifications-read-light.svg";
import notificationDarkIcon from "../../../Assets/Images/notifications-read-dark.svg";
import NotificationPopup from "../../../Common/Notification-Popup/NotificationPopup.js";
import HelloIcon from "../../../Assets/Images/Hello-Icon.svg";
import Table from "../../../Common/Table/Table";
import DashboardCard from "../../../Common/Card/DashboardCard.js";
import cardApplicationsIcon from "../../../Assets/Images/sad-applications.svg";
import cardCandidatesCreatedIcon from "../../../Assets/Images/sad-candidates-created.svg";
import cardJobsCreatedIcon from "../../../Assets/Images/sad-jobs-created.svg";
import cardResumeParsingIcon from "../../../Assets/Images/sad-resume-parsing.svg";
import cardStageUpdatesIcon from "../../../Assets/Images/sad-stage-updates.svg";
import cardTotalLoginIcon from "../../../Assets/Images/sad-total-login.svg";
import cardEmailsSentIcon from "../../../Assets/Images/emails-sent-light.svg";
import cardHeadingArmourIcon from "../../../Assets/Images/super-admin-armour.svg";
import cardChatcovoIcon from "../../../Assets/Images/chat-conversations-light.svg";
import cardChatSendIcon from "../../../Assets/Images/chat-messages-sent-light.svg";
import cardChatBackforthIcon from "../../../Assets/Images/chat-backforth-light.svg";
import MonthFilter from "../../../Common/Month-Filter/MonthFilter.js";
import DynamicAutocomplete from "../../../Common/AutoSuggestion/DynamicAutocomplete.js";
import StageFilterPopup from "../../../Common/StageFilterPopup/StageFilterPopup";
import eyeIcon from "../../../Assets/Images/Eye-Icon.svg";
import DownloadIcon from "../../../Assets/Images/download-white-icon.png";
import SidePopup from "../../../Common/SidePopup/SidePopup.js";
import AdminDashboard from "../Admin-Dashboard/AdminDashboard.js";
import Button from "../../../Common/Button/Button.js";
import {
  formatDateTime,
  formatDate,
} from "../../../Common/Common-Function/CommonFunctions.js";
import VybogTALLoaderAnimation from "../../../Common/Dynamic-Animations/DynamicAnimations.js";
import { Toast } from "../../../Common/Toast-Snackbar/ToastSnackbar.js";

function SuperAdminDashboard() {
  const {
    isDarkMode,
    userDetails,
    notificationsState,
    setNotificationsState,
    tenantDetails,
  } = useContext(DynamicContext);

  const [isNotificationPopupOpen, setIsNotificationPopupOpen] = useState(false);
  const [tenantActivity, setTenantActivity] = useState([]);
  const [tenantActivityLoading, setTenantActivityLoading] = useState(false);
  const [tenantActivityCurrentPage, setTenantActivityCurrentPage] = useState(1);
  const [tenantActivityTotal, setTenantActivityTotal] = useState(0);
  const [platformMetrics, setPlatformMetrics] = useState({
    total_emails_sent: 0,
    total_logins: 0,
    total_resumes_parsed: 0,
    total_jobs_created: 0,
    total_candidates_created: 0,
    total_applications: 0,
    total_stage_updates: 0,
    chat_messages_sent: 0,
    chat_conversations: 0,
    chat_back_and_forths: 0,
  });
  const [selectedDateRange, setSelectedDateRange] = useState("today");
  const [isFilterPopupOpen, setIsFilterPopupOpen] = useState(false);
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [selectedTenant, setSelectedTenant] = useState(null);
  const [tenantOptions, setTenantOptions] = useState([]);
  const [tenantSearch, setTenantSearch] = useState("");
  const [tenantOptionsLoading, setTenantOptionsLoading] = useState(false);
  const [userActivityData, setUserActivityData] = useState([]);
  const [userActivityLoading, setUserActivityLoading] = useState(false);
  const [userActivityCurrentPage, setUserActivityCurrentPage] = useState(1);
  const [userActivityTotal, setUserActivityTotal] = useState(0);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userOptions, setUserOptions] = useState([]);
  const [userSearch, setUserSearch] = useState("");
  const [userOptionsLoading, setUserOptionsLoading] = useState(false);
  const [isTenantDetailOpen, setIsTenantDetailOpen] = useState(false);
  const [selectedTenantDetail, setSelectedTenantDetail] = useState(null);
  const [isUserDetailOpen, setIsUserDetailOpen] = useState(false);
  const [selectedUserDetail, setSelectedUserDetail] = useState(null);
  const [renderSuperAdmin, setRenderSuperAdmin] = useState(true);
  const [tenantSubscription, setTenantSubscription] = useState(null);
  const [subscriptionLoading, setSubscriptionLoading] = useState(false);
  const [tenantExportLoading, setTenantExportLoading] = useState(false);
  const [userExportLoading, setUserExportLoading] = useState(false);

  const notificationSocketRef = useRef(null);
  const notificationPingIntervalRef = useRef(null);
  const notificationPingTimeoutRef = useRef(null);
  const notificationConnectTimeoutRef = useRef(null);
  const notificationReconnectTimeoutRef = useRef(null);
  const notificationReconnectAttemptsRef = useRef(0);
  const notificationConnectingRef = useRef(false);
  const notificationUnmountedRef = useRef(false);
  const previousDateRangeRef = useRef("today");
  const customFilterAppliedRef = useRef(false);

  const notificationUnreadCount = notificationsState?.unread_count || 0;

  const NOTIFICATION_PING_INTERVAL = 30000;
  const NOTIFICATION_PING_TIMEOUT = 10000;
  const MAX_NOTIFICATION_RECONNECT_ATTEMPTS = 5;
  const BASE_NOTIFICATION_RECONNECT_DELAY = 1000;

  const toggleNotificationPopup = (event) => {
    event.stopPropagation();
    setIsNotificationPopupOpen((prev) => !prev);
  };

  const fetchTenantSubscription = useCallback(async (tenantId) => {
    if (!tenantId) return;

    try {
      setSubscriptionLoading(true);
      const response = await get(
        VYLABS_BASE_URL,
        `${SUPERADMIN_TENANT_SUBSCRIPTION}?tenant_id=${encodeURIComponent(tenantId)}`,
      );
      setTenantSubscription(response);
    } catch (error) {
      console.error("Error fetching tenant subscription:", error);
      setTenantSubscription(null);
    } finally {
      setSubscriptionLoading(false);
    }
  }, []);

  const handleViewTenant = (row) => {
    setSelectedTenantDetail(row);
    setIsTenantDetailOpen(true);
    if (row?.tenant_id) {
      fetchTenantSubscription(row.tenant_id);
    }
  };

  const handleCloseTenantDetail = () => {
    setIsTenantDetailOpen(false);
    setTenantSubscription(null);
  };

  const handleViewUser = (row) => {
    setSelectedUserDetail(row);
    setIsUserDetailOpen(true);
  };

  const handleCloseUserDetail = () => {
    setIsUserDetailOpen(false);
  };
  const closeNotificationWebSocket = useCallback(() => {
    if (notificationSocketRef.current) {
      notificationSocketRef.current.close(
        1000,
        "Super Admin dashboard notification cleanup",
      );
      notificationSocketRef.current = null;
    }

    if (notificationPingIntervalRef.current) {
      clearInterval(notificationPingIntervalRef.current);
      notificationPingIntervalRef.current = null;
    }

    if (notificationPingTimeoutRef.current) {
      clearTimeout(notificationPingTimeoutRef.current);
      notificationPingTimeoutRef.current = null;
    }

    if (notificationConnectTimeoutRef.current) {
      clearTimeout(notificationConnectTimeoutRef.current);
      notificationConnectTimeoutRef.current = null;
    }

    if (notificationReconnectTimeoutRef.current) {
      clearTimeout(notificationReconnectTimeoutRef.current);
      notificationReconnectTimeoutRef.current = null;
    }

    notificationConnectingRef.current = false;
  }, []);

  const startNotificationPingInterval = useCallback((ws) => {
    if (notificationPingIntervalRef.current) {
      clearInterval(notificationPingIntervalRef.current);
    }

    const sendPing = () => {
      if (ws.readyState !== WebSocket.OPEN) return;

      ws.send("ping");

      if (notificationPingTimeoutRef.current) {
        clearTimeout(notificationPingTimeoutRef.current);
      }

      notificationPingTimeoutRef.current = setTimeout(() => {
        ws.close(1000, "Notification ping timeout");
      }, NOTIFICATION_PING_TIMEOUT);
    };

    sendPing();

    notificationPingIntervalRef.current = setInterval(
      sendPing,
      NOTIFICATION_PING_INTERVAL,
    );
  }, []);

  const updateNotificationStateFromPayload = useCallback(
    (notificationPayload) => {
      if (!notificationPayload?.id) return;

      setNotificationsState((prev) => {
        const previousNotifications = Array.isArray(prev?.notifications)
          ? prev.notifications
          : [];

        const alreadyExists = previousNotifications.some(
          (item) => item.id === notificationPayload.id,
        );

        const notifications = alreadyExists
          ? previousNotifications.map((item) =>
              item.id === notificationPayload.id
                ? { ...item, ...notificationPayload }
                : item,
            )
          : [notificationPayload, ...previousNotifications];

        return {
          ...prev,
          notifications,
          unread_count:
            typeof notificationPayload.unread_count === "number"
              ? notificationPayload.unread_count
              : (prev?.unread_count || 0) + (alreadyExists ? 0 : 1),
        };
      });
    },
    [setNotificationsState],
  );

  const initializeNotificationWebSocket = useCallback(() => {
    const token = localStorage.getItem("token");

    const isPublicRoute = [
      "/",
      "/login",
      "/signup",
      "/admin-signup",
      "/member-signup",
      "/forgot-password",
      "/reset-password",
    ].includes(window.location.pathname);

    if (
      !token ||
      !userDetails?.id ||
      isPublicRoute ||
      notificationConnectingRef.current
    ) {
      return;
    }

    if (
      notificationSocketRef.current &&
      notificationSocketRef.current.readyState === WebSocket.OPEN
    ) {
      return;
    }

    notificationConnectingRef.current = true;

    if (notificationSocketRef.current) {
      notificationSocketRef.current.close();
    }

    if (notificationPingIntervalRef.current) {
      clearInterval(notificationPingIntervalRef.current);
      notificationPingIntervalRef.current = null;
    }

    if (notificationPingTimeoutRef.current) {
      clearTimeout(notificationPingTimeoutRef.current);
      notificationPingTimeoutRef.current = null;
    }

    if (notificationConnectTimeoutRef.current) {
      clearTimeout(notificationConnectTimeoutRef.current);
      notificationConnectTimeoutRef.current = null;
    }

    if (notificationReconnectTimeoutRef.current) {
      clearTimeout(notificationReconnectTimeoutRef.current);
      notificationReconnectTimeoutRef.current = null;
    }

    const wsProtocol =
      window.location.protocol === "https:" ? "wss://" : "wss://";

    const baseHost = String(WEB_SOCKET_URL)
      .replace(/^wss?:\/\//, "")
      .replace(/^https?:\/\//, "")
      .replace(/^\/+/, "");

    const wsUrl = `${wsProtocol}${baseHost}/ws?token=${encodeURIComponent(
      "Bearer " + token,
    )}&channel_id=${encodeURIComponent(userDetails.id)}`;

    try {
      const ws = new WebSocket(wsUrl);

      notificationSocketRef.current = ws;

      ws.onopen = () => {
        notificationReconnectAttemptsRef.current = 0;
        notificationConnectingRef.current = false;

        startNotificationPingInterval(ws);
      };

      ws.onmessage = (event) => {
        if (event.data === "pong") {
          if (notificationPingTimeoutRef.current) {
            clearTimeout(notificationPingTimeoutRef.current);
            notificationPingTimeoutRef.current = null;
          }

          return;
        }

        try {
          const cleanedMessage = event.data.trim();

          const messageParts = cleanedMessage.split(/\|(.+)/, 2);

          if (messageParts.length !== 2) return;

          const topic = messageParts[0];
          const baseTopic = topic.split(":")[0];

          if (baseTopic !== "notification") {
            return;
          }

          const notificationPayload = JSON.parse(messageParts[1]);

          updateNotificationStateFromPayload(notificationPayload);
        } catch (error) {
          console.error(
            "Error processing notification WebSocket message:",
            error,
          );
        }
      };

      ws.onclose = (event) => {
        notificationConnectingRef.current = false;

        if (notificationPingIntervalRef.current) {
          clearInterval(notificationPingIntervalRef.current);
          notificationPingIntervalRef.current = null;
        }

        if (notificationPingTimeoutRef.current) {
          clearTimeout(notificationPingTimeoutRef.current);
          notificationPingTimeoutRef.current = null;
        }

        if (
          !notificationUnmountedRef.current &&
          event.code !== 1000 &&
          notificationReconnectAttemptsRef.current <
            MAX_NOTIFICATION_RECONNECT_ATTEMPTS
        ) {
          const delay = Math.min(
            BASE_NOTIFICATION_RECONNECT_DELAY *
              Math.pow(2, notificationReconnectAttemptsRef.current),
            30000,
          );

          notificationReconnectTimeoutRef.current = setTimeout(() => {
            notificationReconnectAttemptsRef.current += 1;
            initializeNotificationWebSocket();
          }, delay);
        }
      };

      ws.onerror = (error) => {
        console.warn("Super Admin Notification WebSocket error:", error);

        notificationConnectingRef.current = false;
      };
    } catch (error) {
      console.error("Error creating notification WebSocket:", error);

      notificationConnectingRef.current = false;
    }
  }, [
    startNotificationPingInterval,
    updateNotificationStateFromPayload,
    userDetails?.id,
  ]);

  useEffect(() => {
    const fetchNotificationsForBadge = async () => {
      try {
        const response = await get(
          VYLABS_BASE_URL,
          `${NOTIFICATIONS_GET}?unread_only=true`,
        );

        if (response) {
          setNotificationsState({
            notifications: response?.notifications || [],
            unread_count: response?.unread_count || 0,
          });
        }
      } catch (error) {
        console.error("Super Admin notifications fetch error:", error);
      }
    };

    const token = localStorage.getItem("token");

    const isPublicRoute = [
      "/",
      "/login",
      "/signup",
      "/admin-signup",
      "/member-signup",
      "/forgot-password",
      "/reset-password",
    ].includes(window.location.pathname);

    if (!token || !userDetails?.id || isPublicRoute) {
      return undefined;
    }

    notificationUnmountedRef.current = false;

    fetchNotificationsForBadge();

    notificationConnectTimeoutRef.current = setTimeout(() => {
      initializeNotificationWebSocket();
    }, 250);

    return () => {
      notificationUnmountedRef.current = true;
      closeNotificationWebSocket();
    };
  }, [
    closeNotificationWebSocket,
    initializeNotificationWebSocket,
    setNotificationsState,
    userDetails?.id,
  ]);

  const formatDateForQuery = (date) => {
    const d = new Date(date);

    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
      2,
      "0",
    )}-${String(d.getDate()).padStart(2, "0")}`;
  };

  const getDateRangeQuery = () => {
    if (selectedDateRange === "custom") {
      return `&time=custom${
        fromDate
          ? `&fromDate=${encodeURIComponent(formatDateForQuery(fromDate))}`
          : ""
      }${
        toDate
          ? `&toDate=${encodeURIComponent(formatDateForQuery(toDate))}`
          : ""
      }`;
    }

    return `&time=${encodeURIComponent(selectedDateRange)}`;
  };

  const buildTenantActivityFilters = useCallback(
    () =>
      `${getDateRangeQuery()}${
        selectedTenant?.tenant_id
          ? `&tenant=${encodeURIComponent(selectedTenant.tenant_id)}`
          : ""
      }`,
    [selectedDateRange, selectedTenant, fromDate, toDate],
  );

  const fetchTenantActivity = useCallback(
    async (page = 1) => {
      try {
        setTenantActivityLoading(true);

        const response = await get(
          VYLABS_BASE_URL,
          `${SUPERADMIN_METRICS_ACTIVITY_BY_TENANT}?page=${page}&limit=10${buildTenantActivityFilters()}`,
        );

        setPlatformMetrics({
          total_emails_sent: response?.overall?.emails_sent,
          total_logins: response?.overall?.logins,
          total_resumes_parsed: response?.overall?.resumes_parsed,
          total_jobs_created: response?.overall?.jobs_created,
          total_candidates_created: response?.overall?.candidates_created,
          total_applications: response?.overall?.applications_created,
          total_stage_updates: response?.overall?.stage_updates,
          chat_messages_sent: response?.overall?.chat_messages_sent,
          chat_conversations: response?.overall?.chat_conversations,
          chat_back_and_forths: response?.overall?.chat_back_and_forths,
        });

        const tenants = Array.isArray(response?.tenants)
          ? response.tenants
          : [];

        const formattedTenants = tenants.map((tenant) => ({
          ...tenant,
        }));

        setTenantActivity(formattedTenants);

        setTenantActivityCurrentPage(Number(response?.currentPage ?? page));

        setTenantActivityTotal(Number(response?.total) || 0);
      } catch (error) {
        console.error("error in fetchTenantActivity", error);

        setTenantActivity([]);
        setTenantActivityTotal(0);
      } finally {
        setTenantActivityLoading(false);
      }
    },
    [buildTenantActivityFilters],
  );

  useEffect(() => {
    if (selectedDateRange === "custom" && isFilterPopupOpen) {
      return;
    }

    fetchTenantActivity(1);
  }, [fetchTenantActivity, selectedDateRange, isFilterPopupOpen]);

  const triggerFileDownload = (url) => {
    if (!url) return;
    const link = document.createElement("a");
    link.href = url;
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleExportTenantActivity = async () => {
    try {
      setTenantExportLoading(true);
      const response = await get(
        VYLABS_BASE_URL,
        `${EXPORT_SUPERADMIN_METRICS_ACTIVITY_BY_TENANT}?${buildTenantActivityFilters().replace(
          /^&/,
          "",
        )}`,
      );

      if (response?.url) {
        triggerFileDownload(response.url);
        Toast("success", "Tenant activity exported successfully!");
      } else {
        Toast("warn", "No tenant activity rows to export for current filters.");
      }
    } catch (error) {
      Toast("error", error);
    } finally {
      setTenantExportLoading(false);
    }
  };

  const handleTenantChange = (tenant) => {
    setSelectedTenant(tenant || null);

    setTenantActivityCurrentPage(1);
    setUserActivityCurrentPage(1);

    setSelectedUser(null);
    setUserSearch("");
    setUserOptions([]);
  };

  const handleUserChange = (user) => {
    setSelectedUser(user || null);

    setUserActivityCurrentPage(1);
  };

  const getDisplayDate = (subscription, type) => {
    const status = subscription?.status;
    const dateKey =
      status === "trialing" || status === "paused"
        ? type === "start"
          ? "trial_start"
          : "trial_end"
        : type === "start"
          ? "start_date"
          : "end_date";

    const dateValue = subscription?.[dateKey];
    return dateValue ? formatDate(dateValue) : "N/A";
  };

  const shouldShowCurrentPeriod = (subscription) => {
    return subscription?.cancel_at_period_end === true;
  };
  const dateRangeOptions = [
    {
      label: "Today",
      value: "today",
    },
    {
      label: "Yesterday",
      value: "yesterday",
    },
    {
      label: "Week",
      value: "this_week",
    },
    {
      label: "Month",
      value: "this_month",
    },
    {
      label: "Year",
      value: "this_year",
    },
    {
      label: "Custom",
      value: "custom",
    },
  ];

  const fetchTenantOptions = useCallback(async (search = "") => {
    try {
      setTenantOptionsLoading(true);

      const searchParam = search.trim()
        ? `&search=${encodeURIComponent(search.trim())}`
        : "";

      const response = await get(
        VYLABS_BASE_URL,
        `${SUPERADMIN_METRICS_ACTIVITY_BY_TENANT}?page=1&limit=50${searchParam}`,
      );

      const tenants = Array.isArray(response?.tenants) ? response.tenants : [];

      const formattedOptions = tenants.map((tenant) => ({
        label: tenant?.tenant_name || "",
        value: tenant?.tenant_id || "",
        tenant_id: tenant?.tenant_id || "",
      }));

      setTenantOptions(formattedOptions);
    } catch (error) {
      console.error("Error fetching tenant autocomplete options", error);

      setTenantOptions([]);
    } finally {
      setTenantOptionsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTenantOptions("");
  }, [fetchTenantOptions]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      fetchTenantOptions(tenantSearch);
    }, 300);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [tenantSearch, fetchTenantOptions]);

  const fetchUserOptions = useCallback(
    async (search = "") => {
      if (!selectedTenant?.tenant_id) {
        setUserOptions([]);
        return;
      }

      try {
        setUserOptionsLoading(true);

        const searchParam = search.trim()
          ? `&search=${encodeURIComponent(search.trim())}`
          : "";

        const response = await get(
          VYLABS_BASE_URL,
          `${SUPERADMIN_METRICS_ACTIVITY_BY_USER}?page=1&limit=50&tenant=${encodeURIComponent(
            selectedTenant.tenant_id,
          )}${searchParam}`,
        );

        const users = Array.isArray(response?.users) ? response.users : [];

        const formattedOptions = users.map((user) => ({
          label:
            [user?.first_name, user?.last_name].filter(Boolean).join(" ") ||
            user?.user_name ||
            "",
          value: user?.user_id || "",
          user_id: user?.user_id || "",
        }));

        setUserOptions(formattedOptions);
      } catch (error) {
        console.error("Error fetching user autocomplete options", error);
        setUserOptions([]);
      } finally {
        setUserOptionsLoading(false);
      }
    },
    [selectedTenant],
  );

  useEffect(() => {
    if (selectedTenant?.tenant_id) {
      fetchUserOptions("");
    } else {
      setUserOptions([]);
    }
  }, [selectedTenant, fetchUserOptions]);

  useEffect(() => {
    if (!selectedTenant?.tenant_id) {
      return;
    }

    const timeoutId = setTimeout(() => {
      fetchUserOptions(userSearch);
    }, 300);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [userSearch, selectedTenant, fetchUserOptions]);

  const firstName = userDetails?.first_name || "User";

  const getTenantInitials = (tenantName = "") => {
    const words = tenantName.trim().split(/\s+/).filter(Boolean);

    if (words.length >= 2) {
      return `${words[0][0]}${words[1][0]}`.toUpperCase();
    }

    return tenantName.slice(0, 2).toUpperCase() || "TN";
  };

  const getStatusBadge = (status) => {
    const normalized = (status || "").toLowerCase();

    const statusConfig = {
      active: { label: "Active", className: "status-active" },
      trialing: { label: "Trialing", className: "status-trialing" },
      paused: { label: "Paused", className: "status-paused" },
      canceled: { label: "Canceled", className: "status-canceled" },
      cancelled: { label: "Canceled", className: "status-canceled" },
      past_due: { label: "Past Due", className: "status-past-due" },
    };

    const config = statusConfig[normalized] || {
      label: status || "N/A",
      className: "status-default",
    };

    return (
      <span className={`super-admin-status-badge ${config.className}`}>
        <span className="super-admin-status-dot" />
        {config.label}
      </span>
    );
  };

  const tenantActivityColumns = [
    {
      name: "TENANT",
      selector: (row) => row.tenant_name,
      sortable: true,
      grow: 1.5,

      cell: (row) => (
        <div className="super-admin-tenant-cell">
          <div className="super-admin-tenant-avatar">
            {getTenantInitials(row.tenant_name)}
          </div>

          <div className="super-admin-tenant-info">
            <span className="super-admin-tenant-name">
              {row.tenant_name || "N/A"}
            </span>
          </div>
        </div>
      ),
    },
    {
      name: "STATUS",
      selector: (row) => row.subscription_status,
      sortable: true,
      center: true,
      cell: (row) => getStatusBadge(row.subscription_status),
    },
    {
      name: "LOGINS",
      selector: (row) => row.logins,
      sortable: true,
      center: true,
      cell: (row) => Number(row.logins || 0).toLocaleString(),
    },

    {
      name: "RESUMES PARSED",
      selector: (row) => row.resumes_parsed,
      sortable: true,
      center: true,
      cell: (row) => Number(row.resumes_parsed || 0).toLocaleString(),
    },

    {
      name: "JOBS CREATED",
      selector: (row) => row.jobs_created,
      sortable: true,
      center: true,
      cell: (row) => Number(row.jobs_created || 0).toLocaleString(),
    },

    {
      name: "CANDIDATES CREATED",
      selector: (row) => row.candidates_created,
      sortable: true,
      center: true,
      cell: (row) => Number(row.candidates_created || 0).toLocaleString(),
    },
    {
      name: "Actions",
      cell: (row) => {
        return (
          <div
            style={{
              display: "flex",
              gap: "8px",
              alignItems: "center",
              justifyContent: "center",
              minWidth: "80px",
            }}
          >
            <img
              src={eyeIcon}
              alt="View Tenant"
              style={{
                cursor: "pointer",
                opacity: 0.7,
                transition: "opacity 0.2s",
              }}
              onMouseEnter={(e) => (e.target.style.opacity = 1)}
              onMouseLeave={(e) => (e.target.style.opacity = 0.7)}
              onClick={() => handleViewTenant(row)}
            />
          </div>
        );
      },
      width: "100px",
      center: "true",
      ignoreRowClick: true,
    },
    // {
    //   name: "APPLICATIONS",
    //   selector: (row) => row.applications_created,
    //   sortable: true,
    //   center: true,
    //   cell: (row) => Number(row.applications_created || 0).toLocaleString(),
    // },
    // {
    //   name: "STAGE UPDATES",
    //   selector: (row) => row.stage_updates,
    //   sortable: true,
    //   center: true,
    //   cell: (row) => Number(row.stage_updates || 0).toLocaleString(),
    // },
  ];

  const handleDateRangeChange = useCallback(
    (dateRange) => {
      if (dateRange === "custom") {
        previousDateRangeRef.current = selectedDateRange;

        setSelectedDateRange("custom");
        setIsFilterPopupOpen(true);

        return;
      }

      setSelectedDateRange(dateRange);

      setTenantActivityCurrentPage(1);
      setUserActivityCurrentPage(1);
    },
    [selectedDateRange],
  );

  const applyCustomFilters = (filtersWithValues) => {
    try {
      let selectedFromDate;
      let selectedToDate;

      filtersWithValues.forEach((date) => {
        if (date.type === "from_date") {
          selectedFromDate = date.value;
        }

        if (date.type === "to_date") {
          selectedToDate = date.value;
        }
      });

      const formattedFromDate = formatDateForQuery(selectedFromDate);

      const formattedToDate = formatDateForQuery(selectedToDate);

      setFromDate(formattedFromDate);
      setToDate(formattedToDate);

      setTenantActivityCurrentPage(1);
      setUserActivityCurrentPage(1);

      customFilterAppliedRef.current = true;

      setIsFilterPopupOpen(false);
    } catch (error) {
      console.error("error in applyCustomFilters", error);
    }
  };

  const handleCloseCustomFilter = useCallback(() => {
    setIsFilterPopupOpen(false);

    if (customFilterAppliedRef.current) {
      customFilterAppliedRef.current = false;
      return;
    }

    setSelectedDateRange(previousDateRangeRef.current);
  }, []);

  const buildUserActivityFilters = useCallback(() => {
    const userParam = selectedUser?.user_id
      ? `&user=${encodeURIComponent(selectedUser.user_id)}`
      : "";

    return `${getDateRangeQuery()}&tenant=${encodeURIComponent(
      selectedTenant?.tenant_id || "",
    )}${userParam}`;
  }, [selectedDateRange, selectedTenant, selectedUser, fromDate, toDate]);

  const fetchUserActivity = useCallback(
    async (page = 1) => {
      if (!selectedTenant?.tenant_id) {
        setUserActivityData([]);
        setUserActivityTotal(0);
        return;
      }

      try {
        setUserActivityLoading(true);

        const res = await get(
          VYLABS_BASE_URL,
          `${SUPERADMIN_METRICS_ACTIVITY_BY_USER}?page=${page}&limit=10${buildUserActivityFilters()}`,
        );

        setUserActivityData(Array.isArray(res?.users) ? res.users : []);

        setUserActivityCurrentPage(Number(res?.currentPage ?? page));

        setUserActivityTotal(Number(res?.total) || 0);
      } catch (error) {
        console.error("error in fetchUserActivity", error);

        setUserActivityData([]);
        setUserActivityTotal(0);
      } finally {
        setUserActivityLoading(false);
      }
    },
    [selectedTenant, buildUserActivityFilters],
  );

  useEffect(() => {
    if (selectedDateRange === "custom" && isFilterPopupOpen) {
      return;
    }

    if (selectedTenant?.tenant_id) {
      fetchUserActivity(1);
    } else {
      setUserActivityData([]);
      setUserActivityTotal(0);
    }
  }, [
    fetchUserActivity,
    selectedDateRange,
    selectedTenant,
    selectedUser,
    isFilterPopupOpen,
  ]);

  const handleExportUserActivity = async () => {
    if (!selectedTenant?.tenant_id) return;

    try {
      setUserExportLoading(true);
      const response = await get(
        VYLABS_BASE_URL,
        `${EXPORT_SUPERADMIN_METRICS_ACTIVITY_BY_USER}?${buildUserActivityFilters().replace(
          /^&/,
          "",
        )}`,
      );

      if (response?.url) {
        triggerFileDownload(response.url);
        Toast("success", "User activity exported successfully!");
      } else {
        console.warn("No user activity rows to export for current filters.");
      }
    } catch (error) {
      console.error("error in handleExportUserActivity", error);
    } finally {
      setUserExportLoading(false);
    }
  };

  const userActivityColumns = [
    {
      name: "USER",
      sortable: true,
      center: true,
      cell: (row) => {
        const fullName =
          [row.first_name, row.last_name].filter(Boolean).join(" ") || "N/A";

        return (
          <div className="super-admin-tenant-cell">
            <div className="super-admin-tenant-avatar">
              {getTenantInitials(fullName)}
            </div>
            <div className="super-admin-tenant-info">
              <span className="super-admin-tenant-name">{fullName}</span>
            </div>
          </div>
        );
      },
    },
    {
      name: "LOGINS",
      sortable: true,
      center: true,
      selector: (row) => row.logins,
    },
    {
      name: "RESUMES PARSED",
      sortable: true,
      center: true,
      selector: (row) => row.resumes_parsed,
    },
    {
      name: "JOBS CREATED",
      sortable: true,
      center: true,
      selector: (row) => row.jobs_created,
    },
    {
      name: "CANDIDATES CREATED",
      sortable: true,
      center: true,
      selector: (row) => row.candidates_created,
    },
    {
      name: "LAST SIGN IN",
      sortable: true,
      center: true,
      selector: (row) => row.last_signin,
      cell: (row) => (
        <span>{row.last_signin ? formatDateTime(row.last_signin) : "N/A"}</span>
      ),
    },
    {
      name: "Actions",
      cell: (row) => {
        return (
          <div
            style={{
              display: "flex",
              gap: "8px",
              alignItems: "center",
              justifyContent: "center",
              minWidth: "80px",
            }}
          >
            <img
              src={eyeIcon}
              alt="View Report"
              style={{
                cursor: "pointer",
                opacity: 0.7,
                transition: "opacity 0.2s",
              }}
              onMouseEnter={(e) => (e.target.style.opacity = 1)}
              onMouseLeave={(e) => (e.target.style.opacity = 0.7)}
              onClick={() => handleViewUser(row)}
            />
          </div>
        );
      },
      width: "100px",
      center: "true",
      ignoreRowClick: true,
    },
  ];

  const handleClearCustomFilter = useCallback(() => {
    setFromDate(undefined);
    setToDate(undefined);

    customFilterAppliedRef.current = false;

    setSelectedDateRange("today");

    setIsFilterPopupOpen(false);

    setTenantActivityCurrentPage(1);
    setUserActivityCurrentPage(1);
  }, []);

  return (
    <div>
      {renderSuperAdmin ? (
        <div
          className="super-admin-dashboard"
          style={{ display: "flex", flexDirection: "column", gap: "1vw" }}
        >
          <div className="super-admin-header">
            <div className="super-admin-header-left">
              <div className="super-admin-greeting">
                <h3 className="cephea-text">Hello, {firstName}</h3>

                <img
                  src={HelloIcon}
                  alt="Hello"
                  className="super-admin-hello-icon"
                />
              </div>

              <p>
                Here's a snapshot of your platform's performance across all
                tenants.
              </p>
            </div>

            <div className="super-admin-header-right">
              <div className="super-admin-toggle">
                <Button
                  label="Super Admin"
                  event={() => setRenderSuperAdmin(true)}
                  style={{
                    padding: "5px",
                    fontSize: "12px",
                    borderRadius: "50px",
                  }}
                  backgroundColor="var(--grid-a-bg)"
                  color="var(--grid-a-text)"
                  hoverd={false}
                />
                <Button
                  label="Admin"
                  event={() => setRenderSuperAdmin(false)}
                  style={{
                    padding: "5px",
                    fontSize: "12px",
                    borderRadius: "50px",
                  }}
                  hoverd={false}
                  backgroundColor="var(--grid-bg)"
                  color="var(--grid-na-text)"
                />
              </div>
              <div
                className="super-admin-notification-container"
                onClick={toggleNotificationPopup}
                role="button"
                tabIndex={0}
                aria-label="Notifications"
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    toggleNotificationPopup(event);
                  }
                }}
              >
                <img
                  src={isDarkMode ? notificationDarkIcon : notificationIcon}
                  alt="Notification"
                  className="super-admin-notification-icon"
                />

                {notificationUnreadCount > 0 && (
                  <span className="super-admin-notification-badge">
                    {notificationUnreadCount > 99
                      ? "99+"
                      : notificationUnreadCount}
                  </span>
                )}
              </div>
              <div className="super-admin-brand">
                <div className="super-admin-brand-text">
                  <span className="super-admin-role">SUPER ADMIN</span>

                  <span className="super-admin-company">
                    {tenantDetails?.name}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {isNotificationPopupOpen && (
            <NotificationPopup
              isOpen={isNotificationPopupOpen}
              onClose={() => setIsNotificationPopupOpen(false)}
              notifications={notificationsState?.notifications || []}
              unreadCount={notificationsState?.unread_count || 0}
              isDarkMode={isDarkMode}
            />
          )}
          <div className="super-admin-body">
            <div className="super-admin-dashboard-filters">
              <MonthFilter
                value={selectedDateRange}
                onChange={handleDateRangeChange}
                options={dateRangeOptions}
                ariaLabel="Select date range"
              />

              <StageFilterPopup
                isOpen={isFilterPopupOpen}
                onClose={handleCloseCustomFilter}
                showDateRangeFilter={true}
                isCallStageActive={false}
                showDateFilter={false}
                isUsersFilterActive={false}
                showCandidateViewSelection={false}
                subtitle="Filter by custom date range"
                isDarkMode={isDarkMode}
                onApplyFull={applyCustomFilters}
                popupClassName="super-admin-custom-date-filter-popup"
                fromDate={fromDate}
                toDate={toDate}
                onClear={handleClearCustomFilter}
              />
              <DynamicAutocomplete
                placeholder="Tenants"
                options={tenantOptions}
                value={selectedTenant}
                loading={tenantOptionsLoading}
                onChange={handleTenantChange}
                onInputChange={(event, value, reason) => {
                  if (reason === "input") {
                    setTenantSearch(value);
                  }

                  if (reason === "clear") {
                    setTenantSearch("");
                  }
                }}
                noOptionsText="No tenants found"
                sx={{
                  mt: "5px",
                  width: "100%",
                  ".MuiOutlinedInput-root": {
                    borderRadius: "999px",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "1px solid var(--border__color) !important",
                      borderRadius: "999px",
                      minheight: "auto",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#6860ee",
                      borderRadius: "999px",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#7a70f2",
                      borderRadius: "999px",
                    },
                  },
                  ".MuiInputBase-input": {
                    color: "var(--header__color)",
                    padding: "8px 12px !important",
                    height: "40px",
                    fontFamily: "Satoshi !important",
                  },
                }}
                slotProps={{
                  paper: {
                    sx: {
                      backgroundColor: "var(--body__background)",
                      color: "var(--header__color)",
                      borderRadius: "12px",
                      boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
                      border: "1px solid var(--header__color)",
                    },
                  },
                  listbox: {
                    sx: {
                      "& li": {
                        fontSize: "14px",
                        fontWeight: 500,
                        padding: "8px 16px",
                        color: "var(--header__color)",
                        "&:hover": {
                          backgroundColor: "rgba(0,0,0,0.04)",
                        },
                      },
                    },
                  },
                }}
              />
            </div>
            <section className="super-admin-platform-overview">
              <div className="super-admin-platform-overview-header">
                <div>
                  <div className="super-admin-platform-title-row">
                    <h2>Platform Overview</h2>

                    <span className="super-admin-badge">
                      <img
                        src={cardHeadingArmourIcon}
                        alt="cardHeadingArmourIcon"
                        style={{ marginRight: "5px" }}
                      />
                      Superadmin
                    </span>
                  </div>

                  <p>Activity across all VybogTAL tenants</p>
                </div>
              </div>

              <div className="super-admin-metrics-grid">
                <DashboardCard
                  title="Total Logins"
                  value={platformMetrics.total_logins}
                  trend=""
                  headerIcon={cardTotalLoginIcon}
                  iconBgClass="dashboard-card-icon-bg"
                />
                <DashboardCard
                  title="Resume Parsing"
                  value={platformMetrics.total_resumes_parsed}
                  trend=""
                  headerIcon={cardResumeParsingIcon}
                  iconBgClass="dashboard-card-icon-bg"
                />
                <DashboardCard
                  title="Jobs Created"
                  value={platformMetrics.total_jobs_created}
                  trend=""
                  headerIcon={cardJobsCreatedIcon}
                  iconBgClass="dashboard-card-icon-bg"
                />
                <DashboardCard
                  title="Candidates Created"
                  value={platformMetrics.total_candidates_created}
                  trend=""
                  headerIcon={cardCandidatesCreatedIcon}
                  iconBgClass="dashboard-card-icon-bg"
                />
                <DashboardCard
                  title="Applications"
                  value={platformMetrics.total_applications}
                  trend=""
                  headerIcon={cardApplicationsIcon}
                  iconBgClass="dashboard-card-icon-bg"
                />
                <DashboardCard
                  title="Stage Updates"
                  value={platformMetrics.total_stage_updates}
                  trend=""
                  headerIcon={cardStageUpdatesIcon}
                  iconBgClass="dashboard-card-icon-bg"
                />
                <DashboardCard
                  title="Chat Conversations"
                  value={platformMetrics.chat_conversations}
                  trend=""
                  headerIcon={cardChatcovoIcon}
                  iconBgClass="dashboard-card-icon-bg"
                />
                <DashboardCard
                  title="Chat Messages Sent"
                  value={platformMetrics.chat_messages_sent}
                  trend=""
                  headerIcon={cardChatSendIcon}
                  iconBgClass="dashboard-card-icon-bg"
                />

                <DashboardCard
                  title="Chat Back And Forths"
                  value={platformMetrics.chat_back_and_forths}
                  trend=""
                  headerIcon={cardChatBackforthIcon}
                  iconBgClass="dashboard-card-icon-bg"
                />
                <DashboardCard
                  title="Emails Sent"
                  value={platformMetrics.total_emails_sent}
                  trend=""
                  headerIcon={cardEmailsSentIcon}
                  iconBgClass="dashboard-card-icon-bg"
                />
              </div>
            </section>
            <section className="super-admin-platform-activity">
              <div className="super-admin-platform-overview-header">
                <h2>Platform Activity</h2>
                <Button
                  label={
                    tenantExportLoading
                      ? "Exporting..."
                      : "Export Tenant Activity"
                  }
                  event={handleExportTenantActivity}
                  disabled={tenantExportLoading}
                  iconSrc={DownloadIcon}
                  hoverd={false}
                />
              </div>

              <div className="super-admin-activity-card">
                <Table
                  columns={tenantActivityColumns}
                  data={tenantActivity}
                  progressPending={tenantActivityLoading}
                  pagination
                  paginationServer
                  paginationTotalRows={tenantActivityTotal}
                  currentPage={tenantActivityCurrentPage}
                  paginationPerPage={10}
                  onChangePage={(page) => {
                    setTenantActivityCurrentPage(page);
                    fetchTenantActivity(page);
                  }}
                  hideRowsPerPage
                  highlightOnHover
                  dataNotFoundMessage="No tenant activity found"
                  customStyle={{
                    headCells: {
                      fontSize: "12px",
                      fontWeight: 500,
                      color: "#8b8e98",
                    },

                    cells: {
                      fontSize: "14px",
                    },
                  }}
                />
              </div>
            </section>
            {selectedTenant !== null && (
              <section className="super-admin-platform-activity">
                <div className="super-admin-platform-overview-header">
                  <h2>User Activity ( {selectedTenant?.label || "N/A"} )</h2>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <DynamicAutocomplete
                      placeholder="Users"
                      options={userOptions}
                      value={selectedUser}
                      loading={userOptionsLoading}
                      onChange={handleUserChange}
                      onInputChange={(event, value, reason) => {
                        if (reason === "input") {
                          setUserSearch(value);
                        }

                        if (reason === "clear") {
                          setUserSearch("");
                        }
                      }}
                      noOptionsText="No users found"
                      sx={{
                        mt: "5px",
                        minWidth: "220px",
                        ".MuiOutlinedInput-root": {
                          borderRadius: "999px",
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "1px solid var(--border__color) !important",
                            borderRadius: "999px",
                            minheight: "auto",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#6860ee",
                            borderRadius: "999px",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#7a70f2",
                            borderRadius: "999px",
                          },
                        },
                        ".MuiInputBase-input": {
                          color: "var(--header__color)",
                          padding: "8px 12px !important",
                          height: "40px",
                          fontFamily: "Satoshi !important",
                        },
                      }}
                      slotProps={{
                        paper: {
                          sx: {
                            backgroundColor: "var(--body__background)",
                            color: "var(--header__color)",
                            borderRadius: "12px",
                            boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
                            border: "1px solid var(--header__color)",
                          },
                        },
                        listbox: {
                          sx: {
                            "& li": {
                              fontSize: "14px",
                              fontWeight: 500,
                              padding: "8px 16px",
                              color: "var(--header__color)",
                              "&:hover": {
                                backgroundColor: "rgba(0,0,0,0.04)",
                              },
                            },
                          },
                        },
                      }}
                    />
                    <Button
                      label={
                        userExportLoading
                          ? "Exporting..."
                          : "Export User Activity"
                      }
                      event={handleExportUserActivity}
                      disabled={userExportLoading}
                      iconSrc={DownloadIcon}
                      hoverd={false}
                    />
                  </div>
                </div>

                <div className="super-admin-activity-card">
                  <Table
                    columns={userActivityColumns}
                    data={userActivityData}
                    progressPending={userActivityLoading}
                    pagination
                    paginationServer
                    paginationTotalRows={userActivityTotal}
                    currentPage={userActivityCurrentPage}
                    paginationPerPage={10}
                    onChangePage={(page) => {
                      setUserActivityCurrentPage(page);
                      fetchUserActivity(page);
                    }}
                    hideRowsPerPage
                    highlightOnHover
                    dataNotFoundMessage="No user activity found"
                    customStyle={{
                      headCells: {
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "#8b8e98",
                      },

                      cells: {
                        fontSize: "14px",
                      },
                    }}
                  />
                </div>
              </section>
            )}
            {selectedTenantDetail && (
              <SidePopup
                isOpen={isTenantDetailOpen}
                onClose={handleCloseTenantDetail}
                direction="right"
                sidePopupWidth="420px"
                showHeader={true}
                headerContent={
                  <div className="tenant-detail-header">
                    <div className="tenant-detail-title-block">
                      <h2>{selectedTenantDetail.tenant_name || "N/A"}</h2>
                    </div>
                  </div>
                }
              >
                {subscriptionLoading ? (
                  <VybogTALLoaderAnimation />
                ) : (
                  <div className="tenant-detail-body">
                    <div
                      className="tenant-detail-label"
                      style={{ marginTop: "24px" }}
                    >
                      SUBSCRIPTION DETAILS
                    </div>
                    <div className="tenant-detail-grid">
                      {[
                        {
                          label: "PLAN",
                          value: tenantSubscription?.subscription?.plan_name
                            ? tenantSubscription.subscription.plan_name.toUpperCase()
                            : "N/A",
                        },
                        {
                          label: "STATUS",
                          value: tenantSubscription?.subscription?.status
                            ? tenantSubscription.subscription.status.toUpperCase()
                            : "N/A",
                        },
                        {
                          label: "START DATE",
                          value: getDisplayDate(
                            tenantSubscription?.subscription,
                            "start",
                          ),
                        },
                        {
                          label: "END DATE",
                          value: getDisplayDate(
                            tenantSubscription?.subscription,
                            "end",
                          ),
                        },
                        {
                          label: "CANCEL AT PERIOD END",
                          value:
                            tenantSubscription?.subscription
                              ?.cancel_at_period_end !== undefined
                              ? tenantSubscription.subscription
                                  .cancel_at_period_end
                                ? "YES"
                                : "NO"
                              : "N/A",
                        },
                        ...(shouldShowCurrentPeriod(
                          tenantSubscription?.subscription,
                        )
                          ? [
                              {
                                label: "CURRENT PERIOD START",
                                value: formatDate(
                                  tenantSubscription?.subscription
                                    ?.current_period_start,
                                ),
                              },
                              {
                                label: "CURRENT PERIOD END",
                                value: formatDate(
                                  tenantSubscription?.subscription
                                    ?.current_period_end,
                                ),
                              },
                            ]
                          : []),
                      ].map((item) => (
                        <div
                          className="tenant-detail-stat-card"
                          key={item.label}
                        >
                          <span className="tenant-detail-stat-label">
                            {item.label}
                          </span>
                          <span className="tenant-detail-stat-value">
                            {item.value || "N/A"}
                          </span>
                        </div>
                      ))}
                    </div>
                    <div
                      className="tenant-detail-label"
                      style={{ marginTop: "24px" }}
                    >
                      RESOURCE USAGE
                    </div>
                    <div className="tenant-detail-quota-grid">
                      <div className="tenant-detail-quota-card">
                        <div className="quota-card-header">
                          <span className="quota-card-title">USERS</span>
                          <span className="quota-card-usage">
                            {tenantSubscription?.user_quota?.used || 0} /{" "}
                            {tenantSubscription?.user_quota?.limit || 0}
                          </span>
                        </div>
                        <div className="quota-progress-bar">
                          <div
                            className="quota-progress-fill"
                            style={{
                              width: `${Math.min(((tenantSubscription?.user_quota?.used || 0) / (tenantSubscription?.user_quota?.limit || 1)) * 100, 100)}%`,
                              background:
                                (tenantSubscription?.user_quota?.used || 0) /
                                  (tenantSubscription?.user_quota?.limit || 1) >
                                0.8
                                  ? "#ee343b"
                                  : (tenantSubscription?.user_quota?.used ||
                                        0) /
                                        (tenantSubscription?.user_quota
                                          ?.limit || 1) >
                                      0.6
                                    ? "#f59e0b"
                                    : "#6860ee",
                            }}
                          />
                        </div>
                        <div className="quota-card-footer">
                          <span className="quota-label">
                            Available:{" "}
                            {(tenantSubscription?.user_quota?.limit || 0) -
                              (tenantSubscription?.user_quota?.used || 0)}
                          </span>
                        </div>
                      </div>

                      <div className="tenant-detail-quota-card">
                        <div className="quota-card-header">
                          <span className="quota-card-title">EMAILS</span>
                          <span className="quota-card-usage">
                            {tenantSubscription?.email_quota?.used || 0} /{" "}
                            {tenantSubscription?.email_quota?.limit || 0}
                          </span>
                        </div>
                        <div className="quota-progress-bar">
                          <div
                            className="quota-progress-fill"
                            style={{
                              width: `${Math.min(((tenantSubscription?.email_quota?.used || 0) / (tenantSubscription?.email_quota?.limit || 1)) * 100, 100)}%`,
                              background:
                                (tenantSubscription?.email_quota?.used || 0) /
                                  (tenantSubscription?.email_quota?.limit ||
                                    1) >
                                0.8
                                  ? "#ee343b"
                                  : (tenantSubscription?.email_quota?.used ||
                                        0) /
                                        (tenantSubscription?.email_quota
                                          ?.limit || 1) >
                                      0.6
                                    ? "#f59e0b"
                                    : "#6860ee",
                            }}
                          />
                        </div>
                        <div className="quota-card-footer">
                          <span className="quota-label">
                            Available:{" "}
                            {(tenantSubscription?.email_quota?.limit || 0) -
                              (tenantSubscription?.email_quota?.used || 0)}
                          </span>
                        </div>
                      </div>

                      <div
                        className="tenant-detail-quota-card"
                        style={{ gridColumn: "1 / -1" }}
                      >
                        <div className="quota-card-header">
                          <span className="quota-card-title">CREDITS</span>
                          <span className="quota-card-usage">
                            {tenantSubscription?.credits?.used || 0} /{" "}
                            {tenantSubscription?.credits?.limit || 0}
                          </span>
                        </div>
                        <div className="quota-progress-bar">
                          <div
                            className="quota-progress-fill"
                            style={{
                              width: `${Math.min(((tenantSubscription?.credits?.used || 0) / (tenantSubscription?.credits?.limit || 1)) * 100, 100)}%`,
                              background:
                                (tenantSubscription?.credits?.used || 0) /
                                  (tenantSubscription?.credits?.limit || 1) >
                                0.8
                                  ? "#ee343b"
                                  : (tenantSubscription?.credits?.used || 0) /
                                        (tenantSubscription?.credits?.limit ||
                                          1) >
                                      0.6
                                    ? "#f59e0b"
                                    : "#6860ee",
                            }}
                          />
                        </div>
                        <div className="quota-card-footer">
                          <span className="quota-label">
                            Available:{" "}
                            {(tenantSubscription?.credits?.limit || 0) -
                              (tenantSubscription?.credits?.used || 0)}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tenant-detail-label"
                      style={{ marginTop: "24px" }}
                    >
                      ACTIVITY BREAKDOWN
                    </div>
                    <div className="tenant-detail-grid">
                      {[
                        { label: "Logins", value: selectedTenantDetail.logins },
                        {
                          label: "Resumes Parsed",
                          value: selectedTenantDetail.resumes_parsed,
                        },
                        {
                          label: "Jobs Created",
                          value: selectedTenantDetail.jobs_created,
                        },
                        {
                          label: "Candidates Created",
                          value: selectedTenantDetail.candidates_created,
                        },
                        {
                          label: "Applications",
                          value: selectedTenantDetail.applications_created,
                        },
                        {
                          label: "Stage Updates",
                          value: selectedTenantDetail.stage_updates,
                        },
                        {
                          label: "Chat Messages Sent",
                          value: selectedTenantDetail.chat_messages_sent,
                        },
                        {
                          label: "Chat Conversations",
                          value: selectedTenantDetail.chat_conversations,
                        },
                        {
                          label: "Chat Back & Forths",
                          value: selectedTenantDetail.chat_back_and_forths,
                        },
                      ].map((item) => (
                        <div
                          className="tenant-detail-stat-card"
                          key={item.label}
                        >
                          <span className="tenant-detail-stat-label">
                            {item.label}
                          </span>
                          <span className="tenant-detail-stat-value">
                            {Number(item.value || 0).toLocaleString()}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </SidePopup>
            )}
            {selectedUserDetail && (
              <SidePopup
                isOpen={isUserDetailOpen}
                onClose={handleCloseUserDetail}
                direction="right"
                sidePopupWidth="420px"
                showHeader={true}
                headerContent={
                  <div className="tenant-detail-header">
                    <div className="tenant-detail-title-block">
                      <h2>
                        {[
                          selectedUserDetail?.first_name,
                          selectedUserDetail?.last_name,
                        ]
                          .filter(Boolean)
                          .join(" ") ||
                          selectedUserDetail?.user_name ||
                          "N/A"}
                      </h2>
                    </div>
                  </div>
                }
              >
                <div className="tenant-detail-body">
                  <div
                    className="tenant-detail-label"
                    style={{ marginTop: "16px" }}
                  >
                    USER INFORMATION
                  </div>
                  <div
                    className="tenant-detail-grid"
                    style={{ gridTemplateColumns: "1fr" }}
                  >
                    <div
                      className="tenant-detail-stat-card"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "12px 16px",
                        borderBottom: "1px solid var(--border__color)",
                      }}
                    >
                      <span className="tenant-detail-stat-label">Tenant</span>
                      <span
                        className="tenant-detail-stat-value"
                        style={{ fontSize: "14px", fontWeight: 400 }}
                      >
                        {selectedUserDetail.tenant_name || "N/A"}
                      </span>
                    </div>
                    <div
                      className="tenant-detail-stat-card"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "12px 16px",
                        borderBottom: "1px solid var(--border__color)",
                      }}
                    >
                      <span className="tenant-detail-stat-label">Email</span>
                      <span
                        className="tenant-detail-stat-value"
                        style={{ fontSize: "14px", fontWeight: 400 }}
                      >
                        {selectedUserDetail.email || "N/A"}
                      </span>
                    </div>

                    <div
                      className="tenant-detail-stat-card"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "12px 16px",
                      }}
                    >
                      <span className="tenant-detail-stat-label">
                        Last Sign In
                      </span>
                      <span
                        className="tenant-detail-stat-value"
                        style={{ fontSize: "14px", fontWeight: 400 }}
                      >
                        {formatDateTime(selectedUserDetail.last_signin)}
                      </span>
                    </div>
                  </div>

                  <div
                    className="tenant-detail-label"
                    style={{ marginTop: "24px" }}
                  >
                    ACTIVITY BREAKDOWN
                  </div>
                  <div className="tenant-detail-grid">
                    {[
                      { label: "Logins", value: selectedUserDetail.logins },
                      {
                        label: "Resumes Parsed",
                        value: selectedUserDetail.resumes_parsed,
                      },
                      {
                        label: "Jobs Created",
                        value: selectedUserDetail.jobs_created,
                      },
                      {
                        label: "Candidates Created",
                        value: selectedUserDetail.candidates_created,
                      },
                      {
                        label: "Applications",
                        value: selectedUserDetail.applications_created,
                      },
                      {
                        label: "Stage Updates",
                        value: selectedUserDetail.stage_updates,
                      },
                      {
                        label: "Chat Messages Sent",
                        value: selectedUserDetail.chat_messages_sent,
                      },
                      {
                        label: "Chat Conversations",
                        value: selectedUserDetail.chat_conversations,
                      },
                      {
                        label: "Chat Back & Forths",
                        value: selectedUserDetail.chat_back_and_forths,
                      },
                    ].map((item) => (
                      <div className="tenant-detail-stat-card" key={item.label}>
                        <span className="tenant-detail-stat-label">
                          {item.label}
                        </span>
                        <span className="tenant-detail-stat-value">
                          {Number(item.value || 0).toLocaleString()}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </SidePopup>
            )}
          </div>
        </div>
      ) : (
        <AdminDashboard />
      )}
    </div>
  );
}

export default SuperAdminDashboard;
